import AffixContainer from './AffixContainer';

export default AffixContainer;
